module.exports = {
  "navClickEvent": {
    "name": "nav click event",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string",
        "isOptional": true
      },
      "currentApp": {
        "type": "string"
      },
      "currentUrl": {
        "type": "string"
      },
      "destinationUrl": {
        "type": "string"
      },
      "isNewNav": {
        "type": "boolean"
      },
      "level": {
        "type": [
          "primary",
          "secondary",
          "tertiary",
          ""
        ]
      },
      "target": {
        "type": "string"
      },
      "navGroup": {
        "type": "string",
        "isOptional": true
      },
      "tourStep": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "numOfShortcuts": {
        "type": "number",
        "isOptional": true
      },
      "countDisplayed": {
        "type": "string",
        "isOptional": true
      },
      "discoveryTime": {
        "type": "number",
        "isOptional": true
      },
      "expanded": {
        "type": "boolean",
        "isOptional": true
      },
      "iaVersion": {
        "type": "string",
        "isOptional": true
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  },
  "navFocusEvent": {
    "name": "nav focus event",
    "class": "interaction",
    "properties": {
      "currentApp": {
        "type": "string"
      },
      "currentUrl": {
        "type": "string"
      },
      "isNewNav": {
        "type": "boolean"
      },
      "target": {
        "type": "string"
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  },
  "navSearchBarInteraction": {
    "name": "nav search event",
    "class": "interaction",
    "properties": {
      "queryIdentifier": {
        "type": "string"
      },
      "currentApp": {
        "type": "string"
      },
      "currentUrl": {
        "type": "string"
      },
      "isNewNav": {
        "type": "boolean"
      },
      "results": {
        "type": "string"
      },
      "searchTerm": {
        "type": "string"
      },
      "totalResults": {
        "type": "number"
      },
      "userId": {
        "type": "number"
      },
      "experiments": {
        "type": "array"
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  },
  "navSearchInteraction": {
    "name": "nav search event",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string"
      },
      "value": {
        "type": "string"
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  },
  "navUserImpersonation": {
    "name": "nav view impersonation banner",
    "class": "view",
    "properties": {
      "currentApp": {
        "type": "string"
      },
      "currentUrl": {
        "type": "string"
      },
      "isNewNav": {
        "type": "boolean"
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  },
  "callRemoteInteraction": {
    "name": "call remote interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  },
  "callRemoteAlert": {
    "name": "call remote view alert",
    "class": "view",
    "properties": {
      "alertType": {
        "type": "string",
        "isOptional": true
      },
      "error": {
        "type": "string",
        "isOptional": true
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  },
  "upgradesInteraction": {
    "namespace": "upgrades",
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "upgradeKey": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    }
  },
  "navOptInteration": {
    "name": "nav opt interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "opted in",
        "opted out"
      ],
      "currentApp": {
        "type": "string"
      },
      "currentUrl": {
        "type": "string"
      },
      "isNewNav": {
        "type": "boolean"
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  },
  "helpNotificationDisplay": {
    "name": "help notification indicator displays",
    "class": "view",
    "properties": {
      "currentApp": {
        "type": "string",
        "isOptional": true
      },
      "category": {
        "type": "string",
        "isOptional": true
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  },
  "helpNotificationDismiss": {
    "name": "help notification indicator dismiss",
    "class": "view",
    "properties": {
      "currentApp": {
        "type": "string",
        "isOptional": true
      },
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  },
  "navOptinsEvent": {
    "name": "nav event",
    "class": "interaction",
    "properties": {
      "type": [
        "opt-in",
        "opt-out"
      ],
      "location": [
        "account-menu",
        "global-banner"
      ],
      "navType": {
        "type": [
          "vertical-nav",
          "hubless"
        ]
      }
    },
    "namespace": "nav-v4"
  }
};